module.exports = __webpack_public_path__ + "static/media/delishop_logo.ce58b453.svg";